<template>
    <div :class="classes">
      <slot />
    </div>
</template>

<script>
export default {
  name: 'Panel',
  props: {
    useFontTitle: {
      type: Boolean,
      default: true,
    },
    align: {
      type: String,
      validator: () => ['left', 'right', 'center'],
      default: () => 'center',
    },
  },
  computed: {
    classes() {
      return {
        [`panel-align-${this.align}`]: true,
        panel: true,
        empty: true,
        title: this.useFontTitle,
      };
    },
  },
};
</script>

<style scoped>

</style>
